import { payrollApi } from 'Api/payroll';
import { viewPayrollApi } from 'Api/payrollView';
import { Col, Row } from 'antd';
import { useEffect, useState } from 'react';
import { toastText } from 'utils/utils';
import GlobalHeader from '../GlobalHeader';
import LeaveGratuityPayTable from './Table';

type LeavePayProps = {
	payrollId: any;
	onlyView: boolean;
	headerData: any;
	setLeaveGratuityData: (data: any) => void;
	LeaveGratuityData: any;
	setIsUniversalLoading: any;
	showSteps: boolean;
};

const LeavePayCalculation = (props: LeavePayProps) => {
	const [leavePayLoading, setLeavePayLoading] = useState(false);

	const tableChangeHandler = (
		pagination: any,
		filters: any,
		sorter: any
	) => {};

	const {
		payrollId,
		onlyView,
		headerData,
		setLeaveGratuityData,
		LeaveGratuityData,
		setIsUniversalLoading,
		showSteps,
	} = props;

	const fetchLeaveGratuityData = async (payrollId: string) => {
		try {
			const query = {
				payrollId: payrollId,
			};
			setLeavePayLoading(true);
			setIsUniversalLoading(true);
			let leaveGratuity;
			if (onlyView) {
				leaveGratuity =
					await viewPayrollApi.getAllEmployeesLeaveAndGratuity(query);
			} else {
				leaveGratuity = await payrollApi.getLeaveGratuityPay(query);
			}
			setLeaveGratuityData(leaveGratuity.data.data);
		} catch (err: any) {
			const errorMessage =
				err?.response?.data?.message ||
				'Something went wrong in fetching leave and gratuity record';

			toastText(errorMessage, 'error');
		} finally {
			setLeavePayLoading(false);
			setIsUniversalLoading(false);
		}
	};

	useEffect(() => {
		if (payrollId) {
			fetchLeaveGratuityData(payrollId);
		}
	}, [payrollId]);

	// Updated checkbox handler to support both checkbox types
	const handleCheckboxChange = (id: string, value: boolean, name: string) => {
		const updatedData = LeaveGratuityData.map((item: any) => {
			if (item.employeeId === id) {
				return {
					...item,
					[name]: value,
				};
			}
			return item;
		});
		setLeaveGratuityData(updatedData);
	};

	const handleBulkCheckboxChange = (
		type: 'leave' | 'gratuity',
		value: boolean
	) => {
		const updatedData = LeaveGratuityData.map((item: any) => {
			if (type === 'leave' && !item.alreadyLeavePaid && !onlyView) {
				return { ...item, isLeaveIncluded: value };
			}
			if (type === 'gratuity' && !item.alreadyGratuityPaid && !onlyView) {
				return { ...item, isGratuityIncluded: value };
			}
			return item;
		});
		setLeaveGratuityData(updatedData);
	};
	return (
		<>
			<Row>
				<Col span={24}>
					<GlobalHeader
						headerData={headerData}
						toggleRequired={false}
						isLoading={leavePayLoading}
						fetchAllData={() => fetchLeaveGratuityData(payrollId)}
					/>
				</Col>
			</Row>
			<Row>
				{LeaveGratuityData?.length > 0 && (
					<Row>
						<Col span={24}>
							<div
								style={{
									background: '#f4f1ff',
									paddingInline: '14px',
									paddingBlock: '8px',
									borderRadius: '6px',
									color: '#584495',
								}}
							>
								<b>Note : </b>Once the Leave Pay and Gratuity
								Pay for a relieved employee have been fully
								processed and the payroll is approved, that
								employee will be automatically removed from the
								PayGroup.
							</div>
						</Col>
					</Row>
				)}
				<Col span={24}>
					<LeaveGratuityPayTable
						isLoading={leavePayLoading}
						handleCheckboxChange={handleCheckboxChange}
						employeeData={LeaveGratuityData}
						onlyView={onlyView}
						tableChangeHandler={tableChangeHandler}
						showSteps={showSteps}
						handleBulkCheckboxChange={handleBulkCheckboxChange}
					/>
				</Col>
			</Row>
		</>
	);
};

export default LeavePayCalculation;
